import { render } from "./Overflow.vue?vue&type=template&id=54d261e7&scoped=true"
import script from "./Overflow.vue?vue&type=script&lang=js"
export * from "./Overflow.vue?vue&type=script&lang=js"

import "./Overflow.vue?vue&type=style&index=0&id=54d261e7&scoped=true&lang=less"

import exportComponent from "D:\\perject\\suyuan\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d261e7"]])

export default __exports__